export const config = {
    apiKey: "AIzaSyAbKP_4d0GJ0MAWCBxwRuLqyEpzdqGACQ4",
    authDomain: "myhkferry.firebaseapp.com",
    databaseURL: "https://myhkferry.firebaseio.com",
    projectId: "myhkferry",
    storageBucket: "myhkferry.appspot.com",
    messagingSenderId: "973125236744",
    appId: "1:973125236744:web:653619f307410ad93bf9bd",
    measurementId: "G-3VTQ31561S"
  };